import React, { Component } from 'react';
import { Modal, Row, TabContainer, Nav, NavItem, TabContent, TabPane } from 'react-bootstrap';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { reduxForm } from 'redux-form';
import { toastr } from 'react-redux-toastr';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import { AdminApi } from '../../../../api';
import FeedFilters from './FeedFilters';
import FeedModifiers from './FeedModifiers';
import FeedDetails from './FeedDetails';
import FeedCredentials from './FeedCredentials';
import FeedMapping from './FeedMapping';
import { setLoader, removeLoader } from '../../../../actions';
import { convertMillsToDollars, convertDollarsToMills } from '../../../../utils/helpers/currency';
import { objectDiff } from '../../../../utils/helpers/object_diff';

class EditFeedCampaignForm extends Component {
  onFormSubmit(values) {
    const { resource, template, dispatch, handleHide, campaigns, feedTemplates } = this.props;
    const [campaignData, templateData] = this.sanitizeFormData(this.props.initialValues, values);
    const shouldUpdateCampaign = Object.keys(campaignData).length > 0;
    const shouldUpdateTemplate = Object.keys(templateData).length > 0;

    if (shouldUpdateCampaign || shouldUpdateTemplate) {
      const args = [resource.id, campaignData];

      dispatch(setLoader('adminCampaignForm'));

      dispatch(
        AdminApi.actions.feedCampaignUpdate.post(...args, (_error, success) => {
          if (success) {
            const collection = [...campaigns.data].map(obj => {
              return obj.id === success.data.id ? success.data : obj;
            });

            dispatch({
              type: AdminApi.events.campaign.actionSuccess,
              syncing: false,
              data: { ...campaigns, data: collection, meta: { ...campaigns.meta } },
            });

            if (shouldUpdateTemplate) {
              const templateArgs = [template.id, templateData];
              dispatch(
                AdminApi.actions.feedTemplateUpdate.post(...templateArgs, (_tempError, tempSuccess) => {
                  dispatch(removeLoader('adminCampaignForm'));

                  if (tempSuccess) {
                    toastr.success('Successfully updated campaign and feed template!');
                    const templateCollection = [...feedTemplates.data].map(obj => {
                      return obj.id === tempSuccess.data.id ? tempSuccess.data : obj;
                    });

                    dispatch({
                      type: AdminApi.events.feedTemplate.actionSuccess,
                      syncing: false,
                      data: { ...feedTemplates, data: templateCollection, meta: { ...feedTemplates.meta } },
                    });

                    this.props.destroy();
                    handleHide(true);
                  } else {
                    toastr.warning('Successfully updated campaign details but unable to update feed template!');
                  }
                }),
              );
            } else {
              toastr.success('Successfully updated campaign!');
              this.props.destroy();
              handleHide();
            }
          } else {
            dispatch(removeLoader('adminCampaignForm'));
          }
        }),
      );
    } else {
      toastr.success('Successfully updated campaign and feed template!');
      this.props.destroy();
      handleHide();
    }
  }

  sanitizeFormData(initialValues, values) {
    const { feedFormType } = this.props;
    const modifierList = {};
    const formData = objectDiff(initialValues, values);

    if (formData.credentials) {
      const feedType = ['http', 'http_auth'].includes(formData.feed_type || feedFormType) ? 'http' : 'ftp';

      formData.credentials = { [feedFormType]: formData.credentials[feedType] };
      delete formData.feed_type;
    }

    const campaignData = formData.details || {};
    delete formData.details;
    const templateData = { ...formData };

    if (templateData.unmapped_list || templateData.unmapped_list === '') {
      templateData.unmapped_list = templateData.unmapped_list === '' ? [] : templateData.unmapped_list.split(',');
    }

    if (templateData.modifiers) {
      templateData.modifiers.forEach(m => {
        modifierList[m.field] = { method: m.method, value: m.value };
        return m;
      });
      templateData.modifier_list = { ...modifierList };
      delete templateData.modifiers;
    }

    if (templateData.and) {
      templateData.filter_list = { and: templateData.and };
      delete templateData.and;
    }

    if (templateData.cron || templateData.cron_timezone) {
      templateData.schedule = `${templateData.cron || initialValues.cron} ${templateData.cron_timezone || initialValues.cron_timezone}`;
      delete templateData.cron;
      delete templateData.cron_timezone;
    }

    if (templateData.video === false) {
      if (templateData.mapping) {
        templateData.mapping.videourl = null;
      } else {
        templateData.mapping = { ...initialValues.mapping, videourl: null };
      }
    }

    if (campaignData.bid) {
      campaignData.bid = convertDollarsToMills(campaignData.bid);
    }
    if (campaignData.budget) {
      campaignData.budget = convertDollarsToMills(campaignData.budget);
    }

    return [campaignData, templateData];
  }

  handleShow() {
    const { handleHide, resource, onShow } = this.props;
    handleHide();
    onShow(resource.uuid, resource);
  }

  handleHide(force = false) {
    const { dirty, handleHide } = this.props;
    if (!dirty || force) {
      this.props.destroy();
      handleHide();
    } else {
      toastr.warning('You have unsaved changes to your template.  Please save before exiting or press Close to continue without saving');
    }
  }

  failedValidation(tab) {
    const { validationErrors } = this.props;
    let errors = false;
    Object.keys(validationErrors).forEach(section => {
      if (section === tab) {
        errors = true;
      }
      if (section === 'and' && tab === 'filters') {
        errors = true;
      }
      if (section === 'schedule' && tab === 'details') {
        errors = true;
      }
      if (section === 'root' && tab === 'mapping') {
        errors = true;
      }
    });
    return errors ? 'invalid-tab' : '';
  }

  render() {
    const {
      show,
      handleHide,
      handleSubmit,
      heading,
      isLoading,
      feedFormType,
      isAuthUrl,
      includesVideo,
      useFilters,
      isRecurring,
      initialValues,
      accountOptions,
      submitFailed,
      hasSecureShell,
    } = this.props;

    return (
      <Modal show={show} onHide={this.handleHide.bind(this)} bsSize="large">
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>

        <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))} className="m-t">
          <Modal.Body>
            <TabContainer id="template-tabs" defaultActiveKey="details">
              <div>
                <Row>
                  <Nav bsStyle="tabs">
                    <NavItem eventKey="details">
                      <span className={`${submitFailed && this.failedValidation('details')}`}>Details</span>
                    </NavItem>
                    <NavItem eventKey="credentials">
                      <span className={`${submitFailed && this.failedValidation('credentials')}`}>Credentials</span>
                    </NavItem>
                    <NavItem eventKey="mapping">
                      <span className={`${submitFailed && this.failedValidation('mapping')}`}>Mapping</span>
                    </NavItem>
                    <NavItem eventKey="filters">
                      <span className={`${submitFailed && this.failedValidation('filters')}`}>Filters</span>
                    </NavItem>
                    <NavItem eventKey="modifiers">
                      <span className={`${submitFailed && this.failedValidation('modifiers')}`}>Modifiers</span>
                    </NavItem>
                  </Nav>
                </Row>
                <Row>
                  <TabContent>
                    <TabPane eventKey="details" className="custom-tab-pane">
                      <FeedDetails initialValues={initialValues} isRecurring={isRecurring} accountOptions={accountOptions} />
                    </TabPane>
                    <TabPane eventKey="credentials" className="custom-tab-pane">
                      <FeedCredentials
                        initialValues={initialValues}
                        hasSecureShell={hasSecureShell}
                        feedFormType={feedFormType}
                        isAuthUrl={isAuthUrl}
                      />
                    </TabPane>
                    <TabPane eventKey="mapping" className="custom-tab-pane">
                      <FeedMapping initialValues={initialValues} includesVideo={includesVideo} />
                    </TabPane>
                    <TabPane eventKey="filters" className="custom-tab-pane">
                      <FeedFilters useFilters={useFilters} initialValues={initialValues} />
                    </TabPane>
                    <TabPane eventKey="modifiers" className="custom-tab-pane">
                      <FeedModifiers initialValues={initialValues} />
                    </TabPane>
                  </TabContent>
                </Row>
              </div>
            </TabContainer>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleHide}>Close</Button>
            <Button type="submit" loading={isLoading} bsStyle="info">
              Update
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'AdminFeedCampaignForm',
});

const ResourceModal = connectModal({
  name: 'AdminFeedCampaignModal',
});

const mapStateToProps = state => {
  const {
    loader,
    modal: { AdminFeedCampaignModal },
    admin: { account },
    form: { AdminFeedCampaignForm },
  } = state;
  const isLoading = loader.includes('adminFeedTemplateForm');
  const resource = get(AdminFeedCampaignModal, 'props.resource', {});
  const template = get(AdminFeedCampaignModal, 'props.template', {});
  const values = get(AdminFeedCampaignForm, 'values', null);
  const resourceName = get(AdminFeedCampaignModal, 'props.resourceName', null);
  const campaigns = get(state, 'admin.campaign.data', {});
  const feedTemplates = get(state, 'admin.feedTemplate.data', {});
  const accountOptions = (account.data.data || []).map(a => ({ label: `${a.advertiser} - ${a.name}`, value: a.id }));
  const validationErrors = get(AdminFeedCampaignForm, 'syncErrors', {});
  const feed_type = template.credentials && Object.keys(template.credentials).length > 0 ? Object.keys(template.credentials)[0] : 'http';

  const initialValues = { details: {}, credentials: {}, mapping: {}, and: {} };

  if (resourceName) {
    if (AdminFeedCampaignModal.props.formAction === 'Update') {
      initialValues.details.account_id = resource.account_id;
      initialValues.details.name = resource.name;
      initialValues.details.budget = convertMillsToDollars(resource.budget);
      initialValues.details.recurring = resource.recurring;
      initialValues.details.start_date = resource.start_date;
      initialValues.details.end_date = resource.end_date;
      initialValues.details.status = resource.status;
      initialValues.details.is_open = resource.is_open;

      initialValues.unmapped_list = template.unmapped_list.join(',');

      if (template && template.schedule) {
        const cronSplit = template.schedule.split(' ');
        initialValues.cron = cronSplit.slice(0, -1).join(' ');
        initialValues.cron_timezone = cronSplit[cronSplit.length - 1];
      } else {
        initialValues.cron = '0 */6 * * *';
        initialValues.cron_timezone = 'EST';
      }

      initialValues.root = template.root;
      initialValues.feed_type = feed_type;

      if (template.credentials && template.credentials[feed_type]) {
        if (['http', 'http_auth'].includes(feed_type)) {
          initialValues.credentials.http = template.credentials[feed_type];
        } else if (['ftp', 'sftp'].includes(feed_type)) {
          initialValues.credentials.ftp = template.credentials[feed_type];
        }
      }

      initialValues.mapping = template.mapping;

      initialValues.and = get(template, 'filter_list.and', []);
      initialValues.filter = template.filter || false;
      initialValues.video = template.video || false;

      if (template.modifier_list) {
        initialValues.modifiers = Object.keys(template.modifier_list).map(modifier => {
          return {
            field: modifier,
            method: template.modifier_list[modifier].method,
            value: template.modifier_list[modifier].value,
          };
        });
      } else {
        initialValues.modifiers = [];
      }

      initialValues.gzip = template.gzip || false;
    }
  }

  if (values && values.and.length === 0) {
    delete validationErrors.and;
  }
  if (values && values.modifiers.length === 0) {
    delete validationErrors.modifiers;
  }

  const feedFormType = get(state.form, 'AdminFeedCampaignForm.values.feed_type', feed_type);
  const isAuthUrl = get(state.form, 'AdminFeedCampaignForm.values.credentials.has_auth', false);
  const includesVideo = get(state.form, 'AdminFeedCampaignForm.values.video', false);
  const useFilters = get(state.form, 'AdminFeedCampaignForm.values.filter', false);
  const isRecurring = get(state.form, 'AdminFeedCampaignForm.values.details.recurring', false);
  const hasSecureShell = get(state.form, 'AdminFeedCampaignForm.values.credentials.ftp.ssh_login', false);

  return {
    isLoading,
    initialValues,
    campaigns,
    feedTemplates,
    feedFormType,
    isAuthUrl,
    useFilters,
    isRecurring,
    accountOptions,
    validationErrors,
    includesVideo,
    hasSecureShell,
  };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(EditFeedCampaignForm)));
